<template>
	<div id="app">
		<Header></Header>
		<router-view/>
		<Footer></Footer>
		<GoTop></GoTop>
	</div>
</template>

<script>
export default {
	name: 'App',

	data() {
		return {
			screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
		}
	},

	created() {
		let that = this
		that.fun();
		window.addEventListener("resize", () => {
			location.reload()
			that.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
			that.fun();
		});
	},

	methods: {
		// 设置html标签的字体大小自适应   为了使得rem单位自适应
		fun() {
			const that = this;
			let htmlobj = document.getElementsByTagName("html")[0];
			let os = that.getClient()
			if (os.isAndroid || os.isPhone) {
				// 手机
				htmlobj.style.fontSize = (that.screenWidth / 768) * 16 + "px";
			} else if (os.isTablet) {
				// 平板
				htmlobj.style.fontSize = (that.screenWidth / 996) * 16 + "px";
			} else if (os.isPc) {
				// pc
				htmlobj.style.fontSize = (that.screenWidth / 1440) * 16 + "px";
			}

		},

		getClient() {
			let ua = navigator.userAgent,
				isWindowsPhone = /(?:Windows Phone)/.test(ua),
				isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
				isAndroid = /(?:Android)/.test(ua),
				isFireFox = /(?:Firefox)/.test(ua),
				isChrome = /(?:Chrome|CriOS)/.test(ua),
				isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
				isPhone = /(?:iPhone)/.test(ua) && !isTablet,
				isPc = !isPhone && !isAndroid && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPc: isPc
			}
		}
	}
}
</script>

<style lang="less" scoped>
	#app{
		background: #010920;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue